export const baseURL= location.host.indexOf('8000')!=-1?'/dev-api':'https://clairvoyance-api.csdqsoft.com'
